import React from "react";

const TrancheConfirmationModal = () => {
    return (
        <div className="text-center p-3">
            <p className="mb-0">
                Without a Contact ID, Tranche documents won’t appear on the User
                dashboard. Also You can add it later.
            </p>
        </div>
    );
};

export default TrancheConfirmationModal;

